import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const heroSwiperEl = document.querySelector('.hero-swiper');
    if (heroSwiperEl) {
        const updateAiNoticeVisibility = (swiper) => {
            const activeSlide = swiper.slides[swiper.activeIndex];
            heroSwiperEl.classList.toggle(
                'hero-swiper--hide-ai-notice',
                !!activeSlide && activeSlide.classList.contains('swiper-slide--winner')
            );
        };

        new Swiper(heroSwiperEl, {
            modules: [Autoplay, Pagination],
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            on: {
                init: updateAiNoticeVisibility,
                slideChange: updateAiNoticeVisibility,
            },
        });
    }

     var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
        var u="https://matomo.atw.io/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '52']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();
});

document.addEventListener("DOMContentLoaded", function (event) {

    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');

    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })
});

document.addEventListener('DOMContentLoaded', function () {
  const popups = document.querySelectorAll('.image-popup');
  popups.forEach(popup => {
      popup.addEventListener('click', function (e) {
          e.preventDefault();

          const overlay = document.createElement('div');
          overlay.classList.add('image-popup-overlay');

          const img = document.createElement('img');
          img.src = this.href;
          overlay.appendChild(img);

          document.body.appendChild(overlay);

          img.addEventListener('click', function (e) {
            e.stopPropagation();
            if (img.classList.contains('zoomed')) {
              img.classList.remove('zoomed');
            } else {
              img.classList.add('zoomed');
            }
          });

          overlay.addEventListener('click', function () {
              document.body.removeChild(overlay);
          });
      });
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const bonInfoDialog = document.querySelector('#bon-info-dialog');
    if (!bonInfoDialog) {
        return;
    }

    document.querySelectorAll('[data-behaviour="bon-info-open"]').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            bonInfoDialog.showModal();
            document.body.classList.add('body--modal-open');
        });
    });

    bonInfoDialog.querySelector('[data-behaviour="bon-info-close"]').addEventListener('click', () => {
        bonInfoDialog.close();
    });

    // Klick auf den Backdrop schließt das Popup
    bonInfoDialog.addEventListener('click', (e) => {
        if (e.target === bonInfoDialog) {
            bonInfoDialog.close();
        }
    });

    bonInfoDialog.addEventListener('close', () => {
        document.body.classList.remove('body--modal-open');
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const bonUploadLabel = document.querySelector('[data-behaviour="bon-upload-label"]');
    if (!bonUploadLabel) {
        return;
    }

    const bonInput = bonUploadLabel.closest('label').querySelector('input[type="file"]');
    bonInput.addEventListener('change', () => {
        const file = bonInput.files[0];
        bonUploadLabel.textContent = file ? file.name : 'Upload';
    });
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-behaviour="char-count"]').forEach(counter => {
        const textarea = counter.closest('.field').querySelector('textarea');
        const update = () => {
            counter.textContent = textarea.value.length;
        };
        textarea.addEventListener('input', update);
        update();
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const confirmationDialog = document.querySelector('#participation-confirmation-dialog');
    if (!confirmationDialog) {
        return;
    }

    confirmationDialog.showModal();
    document.body.classList.add('body--modal-open');

    confirmationDialog.querySelector('[data-behaviour="participation-confirmation-close"]').addEventListener('click', () => {
        confirmationDialog.close();
    });

    // Klick auf den Backdrop schließt das Popup
    confirmationDialog.addEventListener('click', (e) => {
        if (e.target === confirmationDialog) {
            confirmationDialog.close();
        }
    });

    confirmationDialog.addEventListener('close', () => {
        document.body.classList.remove('body--modal-open');
    });
});
